// third-party
import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

// project imports
import snackbarReducer from "./slices/snackbar";
import customerReducer from "./slices/customer";
import contactReducer from "./slices/contact";
import productReducer from "./slices/product";
import chatReducer from "./slices/chat";
import calendarReducer from "./slices/calendar";
import mailReducer from "./slices/mail";
import userReducer from "./slices/user";
import cartReducer from "./slices/cart";
import kanbanReducer from "./slices/kanban";
import menuReducer from "./slices/menu";
import equipmentReducer from "./slices/equipment";
import equipmentTypeReducer from "./slices/equipmentType";
import bodypartsReducer from "./slices/bodyparts";
import exercisesReducer from "./slices/exercises";
import exerciseEquipmentReducer from "./slices/exerciseEquipment";
import appUserReducer from "./slices/appUser";
import workoutReducer from "./slices/workout";
import setsReducer from "./slices/sets";
import moduleReducer from "./slices/module";
import locationReducer from "./slices/location";
import qrcodeReducer from "./slices/qrcode";
import exercisetags from "./slices/exercisetags";
import workouttags from "./slices/workouttags";
import appSpecialist from "./slices/appSpecialist";
import gym from "./slices/gym";
import collectionsReducer from "./slices/collections";
import nutritionReducer from "./slices/nutrition";
import coversReducer from "./slices/covers";
// ==============================|| COMBINE REDUCER ||============================== //

const reducer = combineReducers({
  snackbar: snackbarReducer,
  cart: persistReducer(
    {
      key: "cart",
      storage,
      keyPrefix: "berry-",
    },
    cartReducer
  ),
  kanban: kanbanReducer,
  customer: customerReducer,
  contact: contactReducer,
  product: productReducer,
  chat: chatReducer,
  calendar: calendarReducer,
  mail: mailReducer,
  specialist: appSpecialist,
  user: userReducer,
  gym: gym,
  menu: menuReducer,
  equipment: equipmentReducer,
  equipmentType: equipmentTypeReducer,
  bodyparts: bodypartsReducer,
  exercise: exercisesReducer,
  exerciseEquipment: exerciseEquipmentReducer,
  appUser: appUserReducer,
  workout: workoutReducer,
  sets: setsReducer,
  module: moduleReducer,
  exercisetags: exercisetags,
  workouttags: workouttags,
  location: locationReducer,
  qrcode: qrcodeReducer,
  collections: collectionsReducer,
  nutrition: nutritionReducer,
  covers: coversReducer,
});

export default reducer;
